import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import usersReducer from '../features/usersSlice';
import signupReducer from '../features/signupSlice';
import loginReducer from '../features/loginSlice';
import checkoutReducer from '../features/checkoutSlice'


const rootReducer = combineReducers({
  users: usersReducer,
  signup: signupReducer,
  login: loginReducer, //persisted
  checkout: checkoutReducer
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['login','checkout'] 
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);



// export const store = configureStore({
//   reducer: {
//     users: usersReducer,
//     resultsList: resultsListsReducer,
//     ordersHospital: ordersHospitalReducer,
//     ordersOthers: ordersOthersReducer,
//     result: resultReducer,
//     signup: signupReducer,
//     login: loginReducer
//   },
// });
